<template>
  <div>
    <label class="custom-autocomplete-label">
      <strong>{{ label }}</strong>
    </label>

    <v-autocomplete
      dense
      flat
      outlined
      :items="options"
      v-model="value"
      item-text="label"
      item-value="value"
      @input="inputCallback"
      v-bind="$attrs"
      :class="`custom-autocomplete-vueformulate ${validationErrors.items.length ? '' : 'esconde-div-erros'}`"
      v-validate="validation" 
      :data-vv-as="label"
      :error-messages="validationErrors.items.length && valorSofreuMudanca ? [validationErrors.items[0].msg] : []"
      
    />
  </div>
</template>
<script>
export default {
  name: "AutocompleteComponent",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
    },
    options: {
      type: Object,
    },
    validation: {
      type: String,
    },
    value: {},

    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      valorSofreuMudanca: false
    }
  },
  
  methods: {
    inputCallback(value){
      this.$emit('input', value)
      this.$emit('update', {
        name: this.name,
        model: value
      })
    }
  },

  watch: {
    value(val) {
      if (val) {
        this.valorSofreuMudanca = true
      }
    }
  }
};
</script>

<style lang="scss">
.custom-autocomplete-label{
  margin-bottom: 2px;
  font-size: 13px;
}

.custom-autocomplete-vueformulate {
  fieldset{
    height: 36px !important;
    border: 1px solid #ccc !important;
  }

  .v-select__slot {
    height: 28px;

    input {
      font-size: 13px;
    }

    .v-input__append-inner {
      margin-top: 2px !important;
      margin-right: -5px;
    }

    .mdi-menu-down::before {
      font-size: 18px;
      color: #ccc;
    }
  }
}

.esconde-div-erros .v-text-field__details{
  display: none !important;
}
</style>